export default String.raw`
{% if config.Reviews.Enabled and product.Archival == false -%}
	{% assign reviewsExist = true -%}
{% endif -%}

{% assign showManufacturer = false -%}
{% if settings.productDetailsManufacturer == "productDetailsManufacturer-yes" and activeProduct.ResponsibleProducer -%}
	{% assign showManufacturer = true -%}
{% endif -%}

{% assign showResponsiblePerson = false -%}
{% if settings.productDetailsResponsiblePerson == "productDetailsResponsiblePerson-yes" and activeProduct.ResponsiblePerson -%}
	{% assign showResponsiblePerson = true -%}
{% endif -%}

{% comment -%}<!-- Sticky navigation bar -->{% endcomment -%}
{% if product.Description != "" or product.Attachments[0] or reviewsExist or product.SetsExt != empty or product.Related[0] or settings.compareProducts == 'yes' or showManufacturer or showResponsiblePerson -%}
	<div class="product-navigation product-presentation-menu-js nav-not-attached-js">
		<div class="nav">
			<div class="nav__swiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".product-attributes-js">
						<span aria-label="{{ translations.Specification }}" tabindex="0" role="button">{{ translations.Specification }}</span>
					</div>
					{% if product.Description != "" -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".product-description-js">
							<span aria-label="{{ translations.ProductDescription }}" tabindex="0" role="button">{{ translations.ProductDescription }}</span>
						</div>
					{% endif -%}
					{% if showManufacturer or showResponsiblePerson -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".gpsr-container-js">
							<span aria-label="{{ translations.ProductResponsibleEntity }}" tabindex="0" role="button">{{ translations.ProductResponsibleEntity }}</span>
						</div>
					{% endif -%}
					{% if product.Attachments[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".downloads-js">
							<span aria-label="{{ translations.Downloads }}" tabindex="0" role="button">{{ translations.Downloads }}</span>
						</div>
					{% endif -%}
					{% if reviewsExist -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".reviews-js">
							<span aria-label="{{ translations.Reviews }}" tabindex="0" role="button">{{ translations.Reviews }}</span>
						</div>
					{% endif -%}
					{% if product.SetsExt != empty -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".sets-js">
							<span aria-label="{{ translations.Pps_Sets }}" tabindex="0" role="button">{{ translations.Pps_Sets }}</span>
						</div>
					{% endif -%}
					{% if product.RelatedProducts.Accessories[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".related-accessories-js">
							<span aria-label="{{ translations.Accessories }}" tabindex="0" role="button">{{ translations.Accessories }}</span>
						</div>
					{% endif -%}
					{% if product.RelatedProducts.Crossselling[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".related-crossseling-js">
							<span aria-label="{{ translations.OthersAlsoBought }}" tabindex="0" role="button">{{ translations.OthersAlsoBought }}</span>
						</div>
					{% endif -%}
					{% if product.RelatedProducts.Custom[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".related-custom-js">
							<span aria-label="{{ custom.RelationName }}" tabindex="0" role="button">{{ custom.RelationName }}</span>
						</div>
					{% endif -%}
					{% if product.RelatedProducts.Substitutes[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".related-substitutes-js">
							<span aria-label="{{ translations.Substitutes }}" tabindex="0" role="button">{{ translations.Substitutes }}</span>
						</div>
					{% endif -%}
					{% if product.RelatedProducts.Suggested[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".related-suggested-js">
							<span aria-label="{{ translations.Suggested }}" tabindex="0" role="button">{{ translations.Suggested }}</span>
						</div>
					{% endif -%}
					{% if product.RelatedProducts.AIProductsRecommendations[0] -%}
						<div class="swiper-slide nav__wrapper" data-scroll-to-paragraph=".related-ai-js">
							<span aria-label="{{ translations.SimilarProducts }}" tabindex="0" role="button">{{ translations.SimilarProducts }}</span>
						</div>
					{% endif -%}
				</div>
				<div tabindex="0" role="button" class="arrow shadowed nav__prev">
					<svg class="arrow__icon">
						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
					</svg>
				</div>
				<div tabindex="0" role="button" class="arrow shadowed nav__next">
					<svg class="arrow__icon">
						<use href='css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-right-{{ settings.iconStyle }}'></use>
					</svg>
				</div>
			</div>
		</div>

		{% comment -%}<!-- Navigation button -->{% endcomment -%}
		<div class="product-label form-js add-to-cart-js need-product-id-js container-js " data-include="add-to-cart" style="display: none;">
			{% if config.Products.AIEnabled == true -%}
				<input id="sourceToAdd-js" name="source" type="hidden" value=""/>
			{% endif -%}
			<div class="product-label__details">
				{% if activeProduct.Image != null -%}
					<div class="image">
						{{ activeProduct | Img: 'thumb' }}
					</div>
				{% else -%}
					<svg class="no-image">
						<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
					</svg>
				{% endif -%}
				<div class="name-container">
					<div class="name">{{ activeProduct.NameNoHtml }}</div>
					{% if config.ENTERPRISE -%}
						<span class="prices-view-js">
							{% if totalPrice > 0 -%}
								{{ totalPrice | ToPrice }} {{ currencyExt }}
							{% endif -%}
						</span>
					{% else -%}
						{% if price > 0 -%}
						<span>{{ price | ToPrice }} {{ currencyExt }}</span>
						{% endif -%}
					{% endif -%}
				</div>
			</div>
			<div class="product-label__buttons form-js add-to-cart-js container-js add-to-cart-form-container-js need-product-id-js" data-include="add-to-cart">
				<input type="hidden" name="__action" value="Cart/Add" >
				<input type="hidden" name="__template" value="partials/product/product-presentation-data.html" >
				<input name="unitId" type="hidden" value="{{ unitId }}">
				<input type="hidden" name="quantity" value="1">
				{% if config.Products.AIEnabled == true -%}
					<input id="sourceToAdd-js" name="source" type="hidden" value=""/>
				{% endif -%}
				{% if settings.productIsInCart == 'productIsInCart-yes' -%}
					<input type="hidden" id="isInCartId" value="{{activeProduct.Id}}">
				{% endif -%}
				{% assign ifAvailable = true -%}
				{% if activeProduct.Availability.Status == 3 -%}
					{% assign ifAvailable = false -%}
				{% endif -%}
				{% if customer.HidePrices == 'true' and customer.Authenticated == 'false' %}
					{% if settings.signIn == "page" %}
						<a class="primary-action-button" aria-label="sign-in" href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" rel="nofollow" title="{{ translations.LogIn }}">
							<span class="button__text">{{ translations.LogIn }}</span>
							<div class="button__icon">
								<svg width="18" height="20">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</a>
					{% else %}
						<a class="primary-action-button show-login-popup-js" aria-label="sign-in" rel="nofollow" title="{{ translations.LogIn }}">
							<span class="button__text">{{ translations.LogIn }}</span>
							<div class="button__icon">
								<svg width="18" height="20">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#user-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</a>
					{% endif %}
				{% elseif noSimpleProductOnControlledStock and activeProduct.AskForPrice == true -%}
					<div class="buttons-group">
						<button class="primary-action-button load-product-presentation-form-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="ask-for-price">
							<span class="button__text">{{ translations.AskForPrice }}</span>
							<div class="button__icon">
								<svg width="24" height="24">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</button>
					</div>
				{% elseif noSimpleProductOnControlledStock or noSimpleProductWithAttributesOnControlledStock or ifAvailable == false -%}
					<div class="buttons-group">
						<button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-include="notify-about-availability">
							<span class="button__text">{{ translations.NotifyAboutAvailability }}</span>
							<div class="button__icon">
								<svg width="18" height="20">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</button>
					</div>
				{% elseif activeProduct.Price == null or activeProduct.AskForPrice %}
					<div class="buttons-group">
						<button class="primary-action-button load-product-presentation-form-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="ask-for-price">
							<span class="button__text">{{ translations.AskForPrice }}</span>
							<div class="button__icon">
								<svg width="24" height="24">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#comment-alt-dollar-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</button>
					</div>
				{% elseif ifAvailable == false and activeProduct.HasAttributes == false %}
					<div class="buttons-group">
						<button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-include="notify-about-availability">
							<span class="button__text">{{ translations.NotifyAboutAvailability }}</span>
							<div class="button__icon">
								<svg width="18" height="20">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</button>
					</div>
				{% elseif ifAvailable == false and activeProduct.HasAttributes == true %}
					<div class="buttons-group">
						<button aria-label="notify-about-availability" class="primary-action-button load-product-presentation-form-js opening-modal-mobile-js no-supply-product-on-controlled-stock-js" data-template="partials/product/product-presentation-forms.html" data-container=".popup-js" data-url="{{ page.BaseHref }}{{ product.Url }}" data-include="notify-about-availability">
							<span class="button__text">{{ translations.NotifyAboutAvailability }}</span>
							<div class="button__icon">
								<svg width="18" height="20">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#bell-{{ settings.iconStyle }}"></use>
								</svg>
							</div>
						</button>
					</div>       
				{% elseif activeProduct.HasAttributes == true %}
					<div class="buttons-group">
						<button data-url="{{ page.BaseHref }}{{ product.Url }}" class="primary-action-button choose-variant-js">
							<span class="button__text">{{ translations.AvailableProductVariants }}</span>
							<svg class="button__icon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shapes-{{ settings.iconStyle }}"></use>
							</svg>
						</button>
					</div>
				{% else %}
					<div class="buttons-group">
						<button class="primary-action-button add-from-presentation-js add-to-cart-button-js parent-container-reload-js {% if tableView -%} add-many-products-js {% else -%} add-to-cart-update-client-area-js {% endif -%}" {% if newQuery and settings.afterAddingToCart != 1 -%}data-url="{{ dataUrl }}"{% endif -%} {% if customer.Carts[1] -%} data-current-cart-id="{{ currentCartId }}" {% endif -%}>
							<span class="button__text">{{ translations.AddToCart }}</span>
							<svg class="button__icon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{ settings.iconStyle }}"></use>
							</svg>
						</button>
					</div>
				{% endif %}
			</div>
		</div>
	</div>
{% endif -%}
`